import React from 'react';
import usePasswordManagement from '../../hooks/usePasswordManagement';
import MessageModal from '../../components/modals/MessageModal';
import Button from '../../components/common/Button'; // Importando o botão genérico

const AlterarSenha = () => {
  const {
    currentPassword,
    newPassword,
    confirmNewPassword,
    isConfirmPasswordModalOpen,
    message,
    setCurrentPassword,
    setNewPassword,
    setConfirmNewPassword,
    setIsConfirmPasswordModalOpen,
    handleChangePassword,
  } = usePasswordManagement();

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setIsConfirmPasswordModalOpen(true);
        }}
        className="flex flex-col gap-4"
      >
        <div className="input-group">
          <label htmlFor="currentPassword" className="text-gray-700">
            Senha Atual:
          </label>
          <input
            type="password"
            id="currentPassword"
            placeholder="Digite sua senha atual"
            name="currentPassword"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded-lg focus:border-teal-600 focus:ring-teal-600"
          />
        </div>
        <div className="input-group">
          <label htmlFor="newPassword" className="text-gray-700">
            Nova Senha:
          </label>
          <input
            type="password"
            id="newPassword"
            placeholder="Digite sua nova senha"
            name="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded-lg focus:border-teal-600 focus:ring-teal-600"
          />
        </div>
        <div className="input-group">
          <label htmlFor="confirmNewPassword" className="text-gray-700">
            Confirmar Nova Senha:
          </label>
          <input
            type="password"
            id="confirmNewPassword"
            placeholder="Confirme sua nova senha"
            name="confirmNewPassword"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded-lg focus:border-teal-600 focus:ring-teal-600"
          />
        </div>

        {/* Substituindo o botão de "Alterar Senha" pelo botão genérico */}
        <Button
          type="confirmar"
          label="Alterar Senha"
          onClick={() => setIsConfirmPasswordModalOpen(true)}
          className="w-full"
        />

        {message && (
          <div className="text-teal-600 font-semibold mt-4">{message}</div>
        )}
      </form>

      {isConfirmPasswordModalOpen && (
        <MessageModal
          isOpen={isConfirmPasswordModalOpen}
          onClose={() => setIsConfirmPasswordModalOpen(false)}
          onConfirm={handleChangePassword}
          title="Confirmar Alteração de Senha"
          message="Tem certeza que deseja alterar a senha?"
        />
      )}
    </>
  );
};

export default AlterarSenha;
